export class StickyScrollingHeader {
    get direction() {
        let direction = this.lastPosition > this.position ? 'up' : 'down'

        if (this.lastPosition == this.position) {
            direction = this.lastDirection
        }

        return direction
    }

    get position() {
        return window.scrollY
    }

    constructor(headerElSelector) {
        this.timeout = null
        this.lastPosition = 0
        this.lastDirection = null
        this.headerEl = document.querySelector(headerElSelector)

        if (this.headerEl) {
            window.addEventListener('scroll', this.handleScroll.bind(this))
        }

        this.handleScroll()
    }

    handleScroll() {
        if (this.timeout) return

        this.timeout = setTimeout(this.recalculateScrollDirection.bind(this), 150)
    }

    recalculateScrollDirection() {
        this.headerEl.classList.toggle('is-scrolling-up', this.direction == 'up' && this.position > 0)
        this.headerEl.classList.toggle('is-scrolling-down', this.direction == 'down' && this.position > 0)

        this.lastPosition = this.position
        this.lastDirection = this.direction
        this.timeout = null
    }
}
